import { z } from 'zod';

export const EXTERNAL_NETWORK_ENTITY_KINDS = [
  'NETBLOCK',
  'DOMAIN',
  'HOST',
  'GATEWAY',
  'NETWORK_SERVICE',
  'SOFTWARE',
  'STORAGE_SERVICE',
] as const;

export type ExternalNetworkEntityKind =
  (typeof EXTERNAL_NETWORK_ENTITY_KINDS)[number];

export const ExternalNetworkEntityKindSchema = z.enum(
  EXTERNAL_NETWORK_ENTITY_KINDS,
);
